import { createButton } from '@vfde-brix/ws10/button';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import { HtmlId } from '../enums/elementId';
import { mountComponent } from '../util/mount';
import { State } from 'Container/App/selector';
import { getOfferSummaryCardButtonProps } from '../util/components/button.util';
import { JarvisProduct } from '../interface';
import { IOfferSummaryCardProperties } from '@vfde-brix/ws10/offer-summary-card';
import { Button } from '@vfde-brix/ws10/button';

/**
 * Create Brix Button component.
 *
 * @param id - Wrapper ID of the element.
 * @param onClick - OnClick event.
 * @returns - Button component or null if the element with the given ID is not found.
 */
export const mountButton = (id: HtmlId, onClick?: () => void) =>
    mountComponent(id, createButton, onClick
        ? {
            onClick: (event: Event) => {
                event.preventDefault();
                onClick();
            },
        }
        : NO_PATTERN_BUSINESS_LOGIC,
    );

/**
 * Update floating mobile button
 *
 * @param comp - Button component.
 * @param props - OfferPrice button props.
 * @param tariff - Selected tariff info.
 * @param onClick  - OnClick evnt.
 * @param state - State of the app.
 */
export const updateFloatingMobileButton = (
    comp: Button | undefined | null,
    props: IOfferSummaryCardProperties | undefined,
    tariff: JarvisProduct | undefined,
    onClick: () => void,
    state: State,
): void => {
    const { isGigakombi,
        isYoung,
        isAvailabilityChecked,
        isTVProductSelected,
        customer } = state;
    const existingKipId = Boolean(customer?.existingKipId);

    const buttonProps = getOfferSummaryCardButtonProps(
        tariff,
        isGigakombi,
        isYoung,
        isAvailabilityChecked,
        isTVProductSelected,
        existingKipId,
        onClick,
    );

    if (!comp || !props) {
        return;
    }

    comp.update(buttonProps);
};
